// Helper
import { DateInput } from "src/common/__generated__/api/types";
import { ActivityDataByIds, ActivityDataByIdsProps } from "./activity-data-by-ids";

interface ActivityDataFetchProps {
  regionId: string;
  regionName: string;
  startDate: DateInput;
  endDate: DateInput;
  size?: number;
}

const ActivityDataFetch = (props: ActivityDataFetchProps) => {
  const { regionName, regionId, startDate,endDate, size } = props;
  const activityDataByIdsProps: ActivityDataByIdsProps = {
    regionId: regionId,
    regionName: regionName,
    startDate: startDate,
    endDate: endDate,
    size: size
  }

  const { data, error, loading } = ActivityDataByIds(activityDataByIdsProps);
  return { data, error, loading }
}

export { ActivityDataFetch, ActivityDataFetchProps }